module.exports = __webpack_public_path__ + "static/media/Zunavish Logo_white_svg.93acf51e.svg";